import React from 'react';
import { WineRecommendationSet } from './WineRecommendation';

const SOMMELIER_AVATAR = "https://customer-assets.emergentagent.com/job_wine-sommelier-2/artifacts/vu5iglcz_att.ynPmhaFhSeLs5blyB0W6yY3b31D9r_dMDQ9FnJVxofo.jpeg";

const ChatMessage = ({ message, isUser, onRefresh }) => {
  if (isUser) {
    return (
      <div className="flex justify-end mb-4">
        <div className="max-w-[80%]">
          <div className="rounded-2xl px-4 py-2.5 bg-[#D4704A]">
            <p className="text-sm leading-relaxed text-white">{message}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-start mb-4">
      <div className="flex items-start gap-2.5 max-w-[95%]">
        <img 
          src={SOMMELIER_AVATAR}
          alt="Sommelier"
          className="h-9 w-9 rounded-full object-cover shrink-0"
        />
        <div className="flex-1">
          {typeof message === 'string' ? (
            <div className="bg-white rounded-2xl px-4 py-2.5 shadow-sm border border-gray-100">
              <p className="text-sm text-gray-700 leading-relaxed">{message}</p>
            </div>
          ) : message.type === 'text' ? (
            <div className="bg-white rounded-2xl px-4 py-2.5 shadow-sm border border-gray-100">
              <p className="text-sm text-gray-700 leading-relaxed">{message.content}</p>
            </div>
          ) : (
            <WineRecommendationSet recommendation={message} onRefresh={onRefresh} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
